import React from 'react';
import PropTypes from 'prop-types';
import './disclaimer-styles.scss';
import { isValid } from '../../../../utils';

const Disclaimer = ({ data, className, isAffiliate, }) => {
  if (!isValid(data)) { return null; }

  return (isAffiliate
    && <>
        <div className={`${className}-wrapper`}>
            <h2 id="disclaimer" className={`${className}-title`}>{data.header}</h2>
            <div className={`${className}-body`}>{data.body}</div>
        </div>
    </>
  );
};

Disclaimer.propTypes = {
  className: PropTypes.string,
};

export default Disclaimer;
